module.exports = __webpack_public_path__ + "img/contact_map_02.33b14ce7.jpg";